import React, {Component} from 'react';
import {Row,Col,FormControl,Button,ButtonToolbar} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import HrStore from '../../../stores/HrStore';
import InputNumber from 'rc-input-number'
import ConfirmPopup from 'component/element/ConfirmPopup'

var NotificationSystem = require('react-notification-system');
const DESCRIPTION_FIELD = 'description'
const AMOUNT_FIELD = 'amount'
const WITHDRAW_FIELD = 'withdraw'
const BALANCE_FIELD = 'balance'


class SlipContractorDetail extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      loading:false,
      needRefresh:false,
      slip:{},
      profile:null,
      data: {
        wageList: [],
        summary: {
          subsidiaryAmount: '0',
          parentAmount: '0'
        }
      },
      showConfirmDelete:false,
      indexDel:null,
      info:{slip_no:'',employee_id:'',periodic:''}
    }
  }


  componentDidMount(){
    if(this.props.show){
      this.loadContractorSlipDetail(this.props.slipId)
    }
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadContractorSlipDetail(newProps.slipId)
    }else if(this.props.show && newProps.slipId ===''){
      this.setState({data: {
        wageList: [],
        summary: {
          subsidiaryAmount: '0',
          parentAmount: '0'
        }}})
    }else if(this.props.show && newProps.slipId !==this.props.slipId){
        this.loadContractorSlipDetail(newProps.slipId)          
    }
    // console.log('Props',newProps)
  }

  loadContractorSlipDetail(slipId){
    let {data,info} = this.state
    const that =this
    this.setState({loading:true,slipId:slipId})
    HrStore.loadContractorSlipDetail(slipId,(result)=>{
      let {slip_detail,profile}  = result.info
      info.slip_no = result.info.slip_no
      info.employee_id = result.info.employee_id
      info.periodic = result.info.periodic
      data.wageList = slip_detail.income.map((item,index)=>{
        return {
          work_no:item.work_no,
          brand: item.car_detail,
          carRegistrationNo: item.car_registration_no,
          description: item.detail,
          owner_name: item.owner_name,
          // amount: Math.floor(Math.random() * 30000 + 1),
          amount: item.total_income,
          withdraw: item.net_withdraw,          
          balance: (item.total_income - item.net_withdraw),
          receivedBy: '',
          net_payable: item.net_payable*1,
          fixing_order_date:item.fixing_order_date!==undefined?item.fixing_order_date:''
        }
      })
      
      this.setState({loading:false,data:data,slip:slip_detail,profile:profile,info:info})
      this.props.onData(data,slip_detail,info)
    },(error)=>{
      this.setState({loading:false})
    })
  }

  getNumberCommas(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  onSaveClick(e){
    //console.log('onInputBlur',index,field,e)
    let {data,slipId,slip} = this.state
    let that = this
      

      let changed = true
      let total_payable = 0,total_withdraw=0;
      slip.income =  slip.income.map((item,index)=>{
        let withdraw = data.wageList[index].withdraw*1
        if(item.net_withdraw*1 !== withdraw){
          item.net_withdraw = withdraw
          changed = true
        }
        total_payable += data.wageList[index].balance*1;
        total_withdraw += data.wageList[index].withdraw*1;
        return item
      })
      slip.summary.net_payable = total_payable;
      slip.summary.total_withdraw = total_withdraw;
      
    if(changed){
      this.setState({loading:true,needRefresh:true})
        HrStore.saveSlipContractorWithdraw(slipId,slip,function(result){
          that.setState({loading:false})
          that.refs.notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'บันทึกสำเร็จ',
            level: 'info',
            position: 'tc',        
          });
        },function(error){
          // console.log('error',error)
          that.setState({loading:false})
          that.refs.notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'บันทึกล้มเหลว',
            level: 'error',
            position: 'tc',        
          });
        })
    }
  }

  onBackClick(){
    let {needRefresh,slip,data} = this.state

    if(this.props.onBackClick!==undefined)
      this.props.onBackClick(needRefresh)
  }

  onConfirmDelete() {
    let {info,indexDel,data,slip} = this.state
    let item = data.wageList[indexDel]
    let postData = {employee_id:info.employee_id,work_no:item.work_no,periodic:info.periodic}
    HrStore.deleteContractorWithdraw(postData,(result)=>{
      if (result.status=='OK') {
        //data.splice(index, 1);
        slip.income.splice(indexDel,1)
        data.wageList.splice(indexDel,1)
  
        this.setState({indexDel:null,slip:slip,data:data,showConfirmDelete:false})
      }
    },(fail)=>{
      this.setState({indexDel:null,showConfirmDelete:false})
    })
  }

  onInputChange(index,field,e){
    let {data} = this.state
    if (field=='withdraw')
      data.wageList[index][field] = e
    else
      data.wageList[index][field] = e.target.value
    
    data.wageList[index]['balance'] = data.wageList[index]['amount'] - data.wageList[index]['withdraw']*1
    this.setState({data:data})
  }

  addNewLine(val){
    let valLine = val.split('\\n')
    //console.log('newLine',valLine)
    return valLine.map(function(item, key) {
      return (
        <span key={key}>
          {item}
          <br/>
        </span>
      )
    })
  }

  addLineBreak(val) {
    const divStyle = {
      whiteSpace: 'pre-line'
    }
    
    return (
      <div style={divStyle}>
        {this.addNewLine(val)}
      </div>
    )
  }

  renderBody2(){
    const wageList = this.state.data.wageList
    const readonly = (this.props.onBackClick!==undefined)
    
    if(wageList.length===0){
      return (<tr><td colSpan={10}>ไม่พบข้อมูล...</td></tr>)
    }
    return wageList.map((item,index)=>(
       <tr key={index}>
        <td className='text-center'>{index+1}</td>
        <td className='text-center'>{item.brand}</td>
        <td className='text-center'>{item.carRegistrationNo}</td>
        <td>{this.addLineBreak(item.description)}</td>
        <td className='text-center'>{item.owner_name}</td>
        <td className='text-right'>{this.getNumberCommas(item.amount)}</td>
        <td className='text-right'>
        {readonly?<InputNumber
                  className='input-number-format'
                  value={item.withdraw} 
                  onChange={this.onInputChange.bind(this,index,'withdraw')}
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                />:item.withdraw}
        </td>        
        <td className='text-right'>{this.getNumberCommas(item.balance)}</td>
        <td className='text-center'>{item.fixing_order_date}</td>
        <td className='text-center' onClick={()=>{this.setState({showConfirmDelete:true,indexDel:index})}}>{<FontAwesome name='trash' />}</td>     
       </tr>
    ))
  }

  sumWageListColumn(key) {
    const sum = this.state.data.wageList.reduce((acc, row) => (
      acc + parseFloat(row[key])
    ), 0)
    return sum.formatMoney(0)
  }

  renderSummation() {
    const fields = [
      AMOUNT_FIELD,
      WITHDRAW_FIELD,      
      BALANCE_FIELD
    ]
    const tds = fields.map((val, index) => (
      <td key={index} className="text-right">
        {this.sumWageListColumn(val)}
      </td>
    ))

    return (
      <tr>
        <td className='text-center' colSpan={5}>รวมทั้งสิ้น</td>
        {tds}       
        <td className='text-center' colSpan={2}></td> 
      </tr>
    )
  }

  toInteger(val) {
    // if input has typo, reset to zero
    return isNaN(val) ? 0 : parseInt(val)
  }

  renderSummary() {
    const subsidiaryAmount = this.toInteger(this.state.data.summary.subsidiaryAmount)
    const parentAmount = this.toInteger(this.state.data.summary.parentAmount)
    const total = subsidiaryAmount + parentAmount

    return (
      <tr>
        <td className="text-center"colSpan={2}>ส่วนของในเครือ</td>
        <td className="text-right bg-yellow">{subsidiaryAmount.formatMoney(0)}</td>
        <td className="text-center">ส่วนของอู่</td>
        <td className="text-right bg-yellow">{this.sumWageListColumn(WITHDRAW_FIELD)}</td> {/*parentAmount.formatMoney(0)*/}
        <td className="text-center "colSpan={2}>รวม</td>
        <td className="text-right bg-yellow">{this.sumWageListColumn(WITHDRAW_FIELD)}</td> {/*total.formatMoney(0)*/}
        <td className='text-center'  colSpan={2}></td>
      </tr>
    )
  }

  renderTable() {
    
    let {show} = this.props
    let {profile} = this.state
    
    const  mechanicName = (profile!=null)?(profile.first_name+' ('+profile.nick_name+') - '+profile.position):""
    
    return (
      <div style={{display:(show)?'':'none'}}>
        <div className='table-responsive'>
          <table id='employee' className='table table-hover table-bordered-solid' style={{minWidth:'1280px',marginBottom:'0'}}>
            <thead>
              <tr>
                <th className='text-center' colSpan={10}>{'ค่าแรงช่าง'+mechanicName}</th>
              </tr>
              <tr>
                <th className='text-center' rowSpan={2}  style={{width:'50px'}}>ลำดับ</th>
                <th className='text-center' rowSpan={2} style={{width:'150px'}}>ชนิดรถ</th>
                <th className='text-center' rowSpan={2}  style={{width:'150px'}}>ทะเบียน</th>
                <th className='text-center' rowSpan={2}  style={{minWidth:'200px'}}>รายการ</th>
                <th className='text-center' rowSpan={2}  style={{width:'200px'}}>เจ้าของรถ</th>
                <th className='text-center' rowSpan={2}  style={{width:'100px'}}>ราคาเหมา (เหลือเบิก) </th>
                <th className='text-center' colSpan={2}>จำนวนเงิน</th>    
                <th className='text-center' rowSpan={2}  style={{width:'100px'}}>วันเสนอราคา</th>    
                <th className='text-center' rowSpan={2}  style={{width:'60px'}}>ลบ ?</th>            
              </tr>
              <tr>
                <th className='text-center'  style={{width:'100px'}}>เบิก <FontAwesome name='pencil'/></th>                
                <th className='text-center'  style={{width:'80px'}}>คงเหลือ</th>
              </tr>
            </thead>
            <tbody>
              {this.renderBody2()}
              {this.renderSummation()}
              {this.renderSummary()}
            </tbody>
          </table>
        </div>   
        <Row>
          <Col md={12}>
            {this.renderButton()}
          </Col>
        </Row>   
      </div>
    )
  }

  renderButton() {
    let {data} = this.state
    if(this.props.onBackClick!==undefined){
      return (
        <ButtonToolbar className='pull-right'>
          {data.wageList.length>0?(
            <Button  bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึกรายการ</Button>
          ):('')}        
          <Button onClick={this.onBackClick.bind(this)}><FontAwesome name='close' />&nbsp;ปิดตาราง</Button>
        </ButtonToolbar>
      )
    }else{
      return ('')
    }
  }

  render(){
    return (
      <div>
        {this.renderTable()}
        <NotificationSystem ref="notificationSystem" /> 
        <ConfirmPopup
          show={this.state.showConfirmDelete}
          message={'ต้องการลบข้อมูลออกจากรายการสลิปนี้หรือไม่ ?'}
          onHide={()=>{this.setState({showConfirmDelete:false,indexDel:null})}}
          onConfirm={this.onConfirmDelete.bind(this)}
        />
      </div>
    )
  }
}

SlipContractorDetail.defaultProps = {
  show:false,
  slipId:''  
}

export default SlipContractorDetail;





// WEBPACK FOOTER //
// ./src/view/hr/slip/SlipContractorDetail.js